import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState } from '@y42/angular/util';
import { ErrorHandlerService } from '@y42/error-handling';
import { GitService } from '@y42/git';
import { BehaviorSubject } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'y42-git-hard-reset-button',
  templateUrl: './git-hard-reset-button.component.html',
  styleUrls: ['./git-hard-reset-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GitHardResetButtonComponent {
  constructor(private readonly gitService: GitService, private readonly errorHandler: ErrorHandlerService) {}

  private readonly resetting$$ = new BehaviorSubject(false);

  readonly state = connectState(this, {
    resetting: this.resetting$$,
  });

  async hardReset() {
    this.resetting$$.next(true);
    try {
      await this.gitService.hardReset();
      window.location.reload();
    } catch (error) {
      this.errorHandler.handleError(error);
      console.error(error);
    } finally {
      this.resetting$$.next(false);
    }
  }
}
